import ExistingDetailsAccordionSummary from 'home/view/upgrade-order/components/accordions/ExistingDetailsAccordion/summary';
import UpgradeOrderDetailsAccordionSummary from 'home/view/upgrade-order/components/accordions/UpgradeOrderDetailsAccordion/summary';
import PricingQuotationSummary from 'home/view/upgrade-order/components/accordions/PricingQuotation/summary';
import OrderKycComponentSummary from 'home/view/upgrade-order/components/accordions/OrderKycComponent/summary';
import FooterComponent from 'home/view/upgrade-order/components/common/FooterComponent';

const ShiftingSummary = ({ orderDetail }) => {
  return (
    <div className="shifting-summary single-site-upgrade container">
      <ExistingDetailsAccordionSummary orderDetail={orderDetail} />
      <UpgradeOrderDetailsAccordionSummary orderDetail={orderDetail} />
      <PricingQuotationSummary orderDetail={orderDetail} />
      <OrderKycComponentSummary orderDetail={orderDetail} />
    </div>
  );
};

export default ShiftingSummary;
